import { render, staticRenderFns } from "./ProjectSchemesAndDocumentsPdfModal.vue?vue&type=template&id=0ffc610e&scoped=true&"
import script from "./ProjectSchemesAndDocumentsPdfModal.vue?vue&type=script&lang=js&"
export * from "./ProjectSchemesAndDocumentsPdfModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSchemesAndDocumentsPdfModal.vue?vue&type=style&index=0&id=0ffc610e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc610e",
  null
  
)

export default component.exports